<template>
  <div class="logo" :style="`width: ${isCollapse ? '68px' : '164px'} !important;`">
    <img
      :src="isCollapse ? '/logo.png' : '/logo_full.png'"
      style="height: 30px;"
    />
  </div>

  <div class="main">
    <el-page-header @back="goBack" title="返回">
      <template #content>
        <el-breadcrumb separator="/" :disabled="!canGoBack">
          <el-breadcrumb-item
            v-for="route in breadcrumbs"
            :to="route.path"
            :index="route.path"
            :key="route.path"
            >{{ route.name }}</el-breadcrumb-item
          >
        </el-breadcrumb>
        <!-- <div class="title">远程阅片系统</div> -->
      </template>
      <template #extra>
        <div class="userinfo">
          <div class="avatar">
            <el-avatar
              @click="goToProfile"
              :src="profile?.avatar || ''"
            />
          </div>
          <div class="username">{{profile?.loginId}}</div>
          <el-dropdown>
            <el-button :icon="Setting" circle />
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="router.push('/settings/profile')">
                  个人信息
                </el-dropdown-item>
                <el-dropdown-item @click="router.push('/settings/password')">
                  修改密码
                </el-dropdown-item>
                <el-dropdown-item @click="handleLogout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </template>
    </el-page-header>
  </div>
</template>

<style>
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* .title {
  position: fixed;
  top: 18px;
  left: 0;
  width: 100vw;
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  letter-spacing: 4px;
} */

.main {
  width: 100%;
}

.userinfo {
  flex-basis: 80px;
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.avatar {
  margin-right: 1.2rem;
  cursor: pointer;
}

.username {
  margin-right: 1.2rem;
}
</style>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useAuthStore } from '@/stores'
import { Setting } from '@element-plus/icons-vue'
import { logoutService } from '@/api'
import { getCachedProfile } from '@/utils'

const router = useRouter()
const route = useRoute()
const breadcrumbs = ref()
const canGoBack = ref(false)
const isCollapse = ref(false)
const { logout } = useAuthStore()
const profile = ref(getCachedProfile())

const checkCanGoBack = () => {
  canGoBack.value = !!window.history.state?.back
}

const setBreadcrumbs = (r) => {
  breadcrumbs.value = r.matched.filter((r) => r.path !== '/')
}

const handleResize = () => {
  isCollapse.value = window.innerWidth < 1068
}

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})

onMounted(() => {
  setBreadcrumbs(route)
  checkCanGoBack()
  handleResize() // Initialize collapse state based on initial window size
  window.addEventListener('resize', handleResize)

  router.afterEach(() => {
    checkCanGoBack()
  })
})

const goBack = () => {
  if (canGoBack.value) {
    router.back()
  }
}

router.beforeEach((to, from, next) => {
  setBreadcrumbs(to)
  next()
})

const goToProfile = () => {
  router.push('/settings/profile')
}

const handleLogout = async () => {
  const res = await logoutService()

  if (res.code === '1000') {
    logout()
  }
}
</script>
